import React, { useState } from 'react';
import { Header, Footer } from '../components/layout';
import { ShieldAlert, CheckCircle2 } from 'lucide-react';
import { Button, Input } from '../components/common';

export const AbuseContactPage: React.FC = () => {
  const [domain, setDomain] = useState('');
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!domain || !email) return;
    setIsSubmitted(true);
  };

  return (
    <div className="min-h-screen flex flex-col justify-between bg-slate-50 dark:bg-slate-950 transition-colors">
      <Header />
      <main className="flex-1 max-w-4xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl shadow-sm p-8 space-y-8">
          <div className="flex items-center gap-3 border-b border-slate-200 dark:border-slate-800 pb-6">
            <div className="w-12 h-12 rounded-xl bg-rose-100 dark:bg-rose-950/60 flex items-center justify-center text-rose-600 dark:text-rose-400">
              <ShieldAlert className="w-6 h-6" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-slate-100">
                Merchant Delisting & Abuse Contact
              </h1>
              <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
                Fast-track domain exclusion requests and operator contact
              </p>
            </div>
          </div>

          <div className="text-sm text-slate-700 dark:text-slate-300 leading-relaxed space-y-4">
            <p>
              PriceLoss is committed to respectful web usage. If you are an authorized representative of an online retailer and wish to permanently delist your domain from our price monitoring network, please submit the form below or contact our operations desk directly.
            </p>
            <p>
              Direct contact: <a href="mailto:admin@priceloss.com" className="font-semibold text-emerald-600 dark:text-emerald-400 underline">admin@priceloss.com</a>
            </p>
          </div>

          {isSubmitted ? (
            <div className="p-6 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-300 dark:border-emerald-800 rounded-xl text-center space-y-2">
              <CheckCircle2 className="w-8 h-8 text-emerald-600 dark:text-emerald-400 mx-auto" />
              <h3 className="font-semibold text-slate-900 dark:text-slate-100">
                Delisting Request Received
              </h3>
              <p className="text-xs text-slate-600 dark:text-slate-400">
                Your request for <strong>{domain}</strong> has been logged. Our operations team will process the domain exclusion within 24 hours.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4 max-w-lg">
              <Input
                label="Store Domain to Delist"
                placeholder="store.example.com"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
                required
              />
              <Input
                type="email"
                label="Your Official Contact Email"
                placeholder="webmaster@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div>
                <label className="block text-xs font-semibold text-slate-700 dark:text-slate-300 mb-1.5">
                  Reason / Additional Notes (Optional)
                </label>
                <textarea
                  className="w-full px-3.5 py-2 text-sm rounded-lg border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-emerald-500"
                  rows={3}
                  placeholder="Optional context regarding server load or policy..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </div>
              <Button type="submit" variant="destructive" size="md">
                Submit Delisting Request
              </Button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
};
